import React, { ReactNode, useEffect, useState } from 'react';
import { Navbar, NavbarBrand, Nav } from 'reactstrap';
import useSelector from 'hooks/useSelector';
import './NavBar.css';
import { ReactComponent as Logo } from "../../assets/icons/bhp-logo.svg";
import UserMenu from "./UserMenu";
import NavMenuComp from "./NavMenu";
import NotificationsMenu from "./NotificationsMenu";
import { Link } from 'react-router-dom';
import { Menu, Close } from '@mui/icons-material';
import useRoles, { useProfile } from "hooks/useRoles"
import { AnimatedHamburger } from "../ui/Hamburger";

const NavMenu = (props: { show: boolean, toggle: () => void }) => {
    const roleInfo = useRoles();
    const profileInfo = useProfile();
    const cbtcTrained = profileInfo?.cbtcTrained ?? false;

    const handleClick = (e: React.MouseEvent | React.TouchEvent) => {
        if (e.target === e.currentTarget) {
            // user clicked outside the titles
            if (props.show) props.toggle();
        }
    };

    return (
        <div className={"menu-tiles-container " + (props.show ? "show" : "hide")} onClick={handleClick}>
            <NavMenuComp admin={roleInfo.isBOH} onFollowLink={props.toggle} cbtcTrained={cbtcTrained} />
        </div>
    );
}

const FloatingMenu = (props: { isOpen: boolean, toggle: () => void }) => {
    const [startTicks, setStartTicks] = useState(0);

    const toggle = () => {
        setStartTicks(new Date().getTime());
    };

    const onCompleteAnimation = () => {
        props.toggle();
    };

    return (
        <div className={"floating-menu"} onClick={toggle}>
            <AnimatedHamburger
                startTicks={startTicks}
                onComplete={onCompleteAnimation}
                duration={150}
                reverse={!props.isOpen}
                className="hamburger open" />
        </div>
    );
};

const NavBar = () => {
    const [scrolledPastHeader, setScrolledPastHeader] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isTouch, setIsTouch] = useState(false);

    const profile = useSelector(state => state.profile);

    const toggleMenu = () => {
        setIsOpen(!isOpen)
    };

    const touched = () => {
        setIsTouch(true);
        toggleMenu();
    };

    const clicked = () => {
        setIsTouch(false);
        toggleMenu();
    };

    useEffect(() => {
        const onScroll = (e: Event) => {
            const scrollTop = window.scrollY;

            if (scrollTop >= 30 && !scrolledPastHeader) {
                setScrolledPastHeader(true);
            }

            if (scrollTop < 30 && scrolledPastHeader) {
                setScrolledPastHeader(false);
            }
        };

        document.addEventListener("scroll", onScroll);

        return () => {
            document.removeEventListener("scroll", onScroll);
        };
    });

    return (
        <header className={(scrolledPastHeader ? "off-screen" : "on-screen") + " no-text-select" + (isTouch ? " touched" : " moused")}>
            <FloatingMenu isOpen={isOpen} toggle={toggleMenu} />

            <Navbar className="navbar-expand-sm box-shadow" dark>
                <Nav className="mx-auto">
                    <NavbarBrand tag={Link} to="/" >
                        <span>
                            <Logo />
                            <span className="nav-bar-text app-title">Rail Portal</span>
                        </span>
                    </NavbarBrand>
                </Nav>

                <span className="menu-background-container" onTouchEnd={touched} onMouseUp={clicked}>
                    <span className="menu-background">
                        {isOpen && <Close className="hamburger closed" />}
                        {!isOpen && <Menu className="hamburger open" />}
                        <span className="nav-bar-text menu">Menu</span>
                    </span>
                </span>

                <Nav className="navbar-nav">
                    {profile?.id &&
                        <NotificationsMenu />
                    }
                    <UserMenu />
                </Nav>

            </Navbar>
            {profile?.id &&
                <NavMenu show={isOpen} toggle={toggleMenu} />
            }
        </header>
    );
}

export default NavBar;
